import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQS } from "../../lib/site-data";
import { HelpCircle } from "lucide-react";

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-[#F3F4F6] py-20 lg:py-28"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#2563EB]/10 text-[#2563EB] text-xs font-bold uppercase tracking-[0.18em] mb-4">
            <HelpCircle className="h-3.5 w-3.5" />
            FAQ
          </div>
          <h2
            data-testid="faq-heading"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-black text-[#1D2B53] tracking-tight leading-tight"
          >
            Common plumbing questions.
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Quick answers to what homeowners ask us most.
          </p>
        </div>

        <Accordion
          type="single"
          collapsible
          className="mt-12 space-y-3"
          data-testid="faq-accordion"
        >
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-gray-100 rounded-xl px-5 sm:px-6"
            >
              <AccordionTrigger className="text-left font-display text-base sm:text-lg font-bold text-[#1D2B53] hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] text-gray-600 leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
